import React from 'react';
import './style.css'
import users from '../../services/users/index';

export default class InitialConfigComponent extends React.Component {
    state = {
        modal: true,
        fields: {
            userName: "",
            password: "",
            confirm: "",
            pin: ""
        },
        errors: {
            userName: "",
            password: "",
            confirm: "",
            pin: ""
        }
    }

    componentWillMount() {
        this.props.addCommand();
    }

    onInputChange = (e) => {
        let {name, value} = e.target;
        let newFields = Object.assign({}, this.state.fields);
        let newErrors = Object.assign({}, this.state.errors)
        newFields[name] = value;
        newErrors[name] = "";
        this.setState({fields: newFields, errors: newErrors})
    }

    hasError = () => {
        let hasError = false;
        let errors = Object.assign({},this.state.errors)

        if(this.state.fields.userName == "mreina" || this.state.fields.userName == "admin"){
            errors.userName = "No se puede usar ese nombre de usuario."
            hasError = true;
        }

        if(this.state.fields.pin == "2020") {
            errors.pin = "No se puede utilizar ese pin."
            hasError = true;
        }

        if(this.state.fields.password !== this.state.fields.confirm) {
            errors.confirm = "La confirmación y la contraseña no coinciden"
            hasError = true;
        }

        if(!this.state.fields.userName){
            errors.userName = "Introduzca un nombre de usuario"
            hasError = true
        } else if(this.state.fields.userName.length < 5) {
            errors.userName = "El nombre de usuario debe tener al menos 5 caracteres."
            hasError = true
        }

        if(!this.state.fields.password){
            errors.password = "Introduzca una contraseña"
            hasError = true
        } else if(this.state.fields.password.length < 6) {
            errors.password = "La contraseña debe tener al menos 6 caracteres"
            hasError = true
        }

        if(!this.state.fields.pin){
            errors.pin = "Introduzca un pin"
            hasError = true
        } else if(this.state.fields.pin.length !== 4) {
            errors.pin = "El pin debe de ser de 4 caracteres"
            hasError = true
        }

        this.setState({errors: errors})

        return hasError;
    }

    submit = (e) => {
        e.preventDefault();
        if(!this.hasError()) {
            let {userName, password, pin} = this.state.fields;

            users.insert({validated: true})

            users.insert({
                userName: userName,
                password: password,
                role: "admin",
                status: "activo",
                pin: pin
            }, (err, user) => {
                this.props.removeCommand();
                this.props.register(user);
            })
        }
    }

    render() {
        return (
            <div className="InitialConfig container">
                <div className="position-size">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-header-title">Configuración de cuenta de administrador</h3>
                        </div>
                        <div className="card-content">
                            <form id="form" className="content" onSubmit={this.submit}>
                                <div className="field">
                                    <label className="label">Nombre de usuario</label>
                                    <div className="control has-icons-left has-icons-right">
                                        <input value={this.state.fields.userName}
                                            onChange={this.onInputChange} name="userName"
                                            className={!this.state.errors.userName ? "input" : "input is-danger"}
                                            type="text"/>
                                        <span className="icon is-small is-left">
                                            <i className="fas fa-user"></i>
                                        </span>
                                        {this.state.errors.userName ? <p className="help is-danger">{this.state.errors.userName}</p> :
                                            <p><br /></p>}
                                    </div>
                                </div>
                                <div className="field">
                                    <label className="label">Contraseña</label>
                                    <div className="control has-icons-left has-icons-right">
                                        <input value={this.state.fields.password}
                                            onChange={this.onInputChange} name="password"
                                            className={!this.state.errors.password ? "input" : "input is-danger"}
                                            type="password"/>
                                        <span className="icon is-small is-left">
                                            <i className="fas fa-lock"></i>
                                        </span>
                                        {this.state.errors.password ? <p className="help is-danger">{this.state.errors.password}</p> :
                                            <p><br /></p>}
                                    </div>
                                </div>
                                <div className="field">
                                    <label className="label">Confirmar contraseña</label>
                                    <div className="control has-icons-left has-icons-right">
                                        <input value={this.state.fields.confirm}
                                            onChange={this.onInputChange} name="confirm"
                                            className="input" type="password"/>
                                        <span className="icon is-small is-left">
                                            <i className="fas fa-key"></i>
                                        </span>
                                        {this.state.errors.confirm ? <p className="help is-danger">{this.state.errors.confirm}</p> :
                                            <p><br /></p>}
                                    </div>
                                </div>
                                <div className="field">
                                    <label className="label">Pin (4 dígitos)</label>
                                    <div className="control has-icons-left has-icons-right">
                                        <input value={this.state.fields.pin}
                                            maxLength={4} minLength={4}
                                            onChange={this.onInputChange} name="pin"
                                            className={!this.state.errors.password ? "input" : "input is-danger"}
                                            type="password"/>
                                        <span className="icon is-small is-left">
                                            <i className="fas fa-th"></i>
                                        </span>
                                        {this.state.errors.pin ? <p className="help is-danger">{this.state.errors.pin}</p> :
                                            <p><br /></p>}
                                    </div>
                                </div>
                            </form>
                        </div>
                        <footer className="card-footer">
                            <button form="form" type="submit" className="button is-primary">Crear cuenta</button>
                        </footer>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/initial-config/index.js